// import { useState, useEffect } from "react";
// import dynamic from "next/dynamic";

// const getIsMobile = () => global?.window && window.innerWidth <= 768;

// export default function useIsMobile() {
//   const [isMobile, setIsMobile] = useState(getIsMobile());

//   useEffect(() => {
//     const onResize = () => {
//       setIsMobile(getIsMobile());
//     };

//     window.addEventListener("resize", onResize);

//     return () => {
//       window.removeEventListener("resize", onResize);
//     };
//   }, []);

//   return isMobile;
// }


import { useState, useEffect } from "react";
import { isMobile as deviceDetectIsMobile } from "react-device-detect";
 
export default function useIsMobile() {
  const [isClientMobile, setIsClientMobile] = useState(deviceDetectIsMobile);
 
  useEffect(() => {
    const checkIsMobile = () => window.innerWidth <= 768;
 
    // Update the state with the actual window size on mount
    setIsClientMobile(checkIsMobile());
 
    // Listen for resize events to update if screen size changes
    const handleResize = () => {
      setIsClientMobile(checkIsMobile());
    };
 
    window.addEventListener("resize", handleResize);
 
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
 
  return isClientMobile;
}